import React, { useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { FormattedMessage } from 'react-intl';
import { makeStyles } from '@material-ui/core';

/* eslint-disable import/prefer-default-export */

const useStyles = makeStyles(theme => ({
  success: {
    '& .MuiSnackbarContent-root': {
      backgroundColor: theme.palette.success.main,
    },
  },
  error: {
    '& .MuiSnackbarContent-root': {
      backgroundColor: theme.palette.error.main,
    },
  },
  warning: {
    '& .MuiSnackbarContent-root': {
      backgroundColor: theme.palette.warning.main,
    },
  },
  info: {
    '& .MuiSnackbarContent-root': {
      backgroundColor: theme.palette.info.main,
    },
  },
}));

export const useSnackbarListener = (message, variant = 'error') => {
  const style = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (!message) return;
    enqueueSnackbar(
      <FormattedMessage id={message} defaultMessage={message} />,
      { variant, className: style[variant] }
    );
  }, [message]);
};
